import React, {useState} from "react";
import Multiselect from ".";

export default function FeatureFields({featureData, index, handleAllModalEvents}) {
  const [eventLists, setEventList] = useState(featureData.eventLists);
  
  const handleEvents = (value, index) => {
    return handleAllModalEvents("pageLists", value, index);
  };
  const handlePage = (value, index) =>{
    const finalValues = featureData?.eventLists.filter((ele)=> ele.routeId === value.routeId && ele.enable);
    setEventList(finalValues);
    return handleAllModalEvents("page", value.label, index, value.routeId);
  }

  return (
    <div className=" flex gap-8">     
      <Multiselect
        selectDefault={[]}
        index={index}
        titleLists={featureData.titleLists}
        placeholder={"Choose Page"}
        handleChange={(value, index) => handlePage(value, index)   }
        isMultiselect={false}
      />
      <Multiselect
        selectDefault={[]}
        index={index}
        titleLists={eventLists}
        placeholder={"Choose Events"}
        handleChange={(value, index) => handleEvents(value, index)}
      />
    </div>
  );
}
